import { GrowthBook } from '@growthbook/growthbook';
import { v4 } from 'uuid';
import { readMeta, readDomainCookie, jwtData } from './jwt_helper';

function writeDomainCookie(name, value, options = {}) {
  const d = readMeta('cookie_domain');
  let optionsObject = options;
  if (d) optionsObject = { domain: d, ...options };
  if (Object.keys(optionsObject).length) {
    Cookies.set(name, value, optionsObject);
  } else {
    Cookies.set(name, value);
  }
}

const FamilyConciergeRole = 'com.sittercity.empire:Role.family_concierge';
const SitterRole = 'com.sittercity.empire:Role.provider';
const ParentRole = 'com.sittercity.empire:Role.seeker';
const PremiumRole = 'com.sittercity.empire:Role.premium_seeker';
const CorporateRole = 'com.sittercity.empire:Role.corporate_seeker';
const FeaturedSitterRole = 'com.sittercity.empire:Role.featured_provider';

const roleMap = {
  FamilyConciergeRole: 'family_concierge',
  SitterRole: 'sitter',
  ParentRole: 'basic',
  PremiumRole: 'premium',
  CorporateRole: 'corporate',
  FeaturedSitterRole: 'featured_sitter',
}

const accountRole = () => {
  const { roles } = jwtData();

  if (!roles) return null;

  // ensure the correct order of precedence
  const found = [
    FamilyConciergeRole,
    CorporateRole,
    PremiumRole,
    ParentRole,
    FeaturedSitterRole,
    SitterRole,
  ].find((role) => roles.includes(role));

  if (!found) return null;
  return roleMap[found];
}

let gb = null;

const generateCookie = () => {
  const COOKIE_NAME = 'gbuuid';
  const COOKIE_DAYS = 400;

  const existingId = readDomainCookie(COOKIE_NAME);
  if (existingId) return existingId;

  const newCookieId = v4();
  writeDomainCookie(COOKIE_NAME, newCookieId, { expires: COOKIE_DAYS });
  return newCookieId;
};

const client = () => {
  return gb;
};

const resetGrowthbook = () => {
  gb = null;
};

async function initGrowthbook() {
  if (gb) return gb; // Return the existing instance if already initialized

  const gbClientKey = readMeta('growthbook-client-key');
  const gbDevMode = readMeta('growthbook-dev-mode').toLowerCase() === 'true';

  if (!gbClientKey) {
    console.error('GrowthBook client key missing');
    return null;
  }

  const userId = jwtData()?.sub;
  const autoExperiments = true;
  const url = window.location.href;
  const gbuuid = generateCookie();
  const role = accountRole();

  const sendSegmentEvent = (experimentId, variationId) => {
    window.analytics.track("Experiment Viewed", { experimentId, variationId, gbuuid });
  }

  try {
    gb = new GrowthBook({
      clientKey: gbClientKey,
      enableDevMode: gbDevMode,
      autoExperiments,
      attributes: { id: gbuuid, userId, gbuuid, role, url },
      trackingCallback: (experiment, result) => {
        if (window.analytics) {
          sendSegmentEvent(experiment.key, result.key);
        }
        else {
          window.addEventListener('segmentLoaded', () => {
            sendSegmentEvent(experiment.key, result.key);
          });
        }
      }
    });
    await gb.init({ streaming: true });
    if (typeof window !== 'undefined') {
      window.growthbookClient = gb;
      window.dispatchEvent(new CustomEvent('growthbookReady', { detail: gb }));
    }
    return gb;
  } catch (e) {
    console.error('Error initializing GrowthBook:', e);
    return null;
  }
}

export { client, resetGrowthbook, initGrowthbook };
